<app-type-procFNS
[uid]="getUid()"
[parentForm]="parentForm"

[disabled]="disabled"
[procedure]="fnSimpleInitial.procedure"
></app-type-procFNS>